import { render, staticRenderFns } from "./ColumnPostTitle.vue?vue&type=template&id=0ca791c5&"
import script from "./ColumnPostTitle.vue?vue&type=script&lang=js&"
export * from "./ColumnPostTitle.vue?vue&type=script&lang=js&"
import style0 from "./ColumnPostTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports